import React, { useState, useEffect } from 'react'
import { CircularProgress } from '@mui/material'
import AlertDialog from '../../../../../../../components/AlertDialog/index.es6'
import ButtonInc from '../../../../../../../shared-ui/ButtonInc'

const EmailDocument = props => {
  const [email, setEmail] = useState('')

  useEffect(() => {
    if (props.policy) {
      setEmail(props.defaultEmail || '')
    }
  }, [props.policy, props.defaultEmail])

  if (!props.policy) {
    return ''
  }

  const cancel = () => {
    props.resetEntity()
  }
  const sendEmail = () => {
    props.emailDocument(email)
  }
  const handleEmailSentSuccessfully = () => {
    props.resetEmailDocumentSuccessAlert()
    props.resetEntity()
  }
  const handleEmailError = () => {
    props.resetEmailDocumentErrorAlert()
  }

  return (
    <>
      <AlertDialog
        custom
        show={
          !props.showEmailDocumentProgressAlert &&
          !props.showEmailDocumentSuccessAlert &&
          !props.showEmailDocumentErrorAlert
        }
        size="sm"
        title="Email policy document to customer"
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => sendEmail()}
        onCancel={() => cancel()}
        confirmBtnText="Send"
        showCancel
        showConfirm
        cancelBtnText="Cancel"
        confirmBtnCssClass
        confirmBtnDisabled={!email}
      >
        <p>Send the policy document to:</p>
        <input
          type="email"
          value={email}
          onChange={event => setEmail(event.target.value)}
          placeholder="customer@example.com"
          style={{ width: '80%', padding: '8px', marginTop: '8px' }}
        />
      </AlertDialog>

      <AlertDialog
        custom
        show={props.showEmailDocumentProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        showCancel={false}
        showConfirm={false}
        showTitle={false}
      >
        <CircularProgress />
        <h2>Sending Email...</h2>
      </AlertDialog>

      <AlertDialog
        success
        show={props.showEmailDocumentSuccessAlert}
        size="sm"
        title="Email sent"
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => handleEmailSentSuccessfully()}
        confirmBtnText="Ok"
        showCancel={false}
        showConfirm={false}
      >
        <div>
          <ButtonInc
            onClick={() => handleEmailSentSuccessfully()}
            style={{ background: 'green' }}
          >
            OK
          </ButtonInc>
        </div>
      </AlertDialog>

      <AlertDialog
        show={props.showEmailDocumentErrorAlert}
        danger
        title="Error sending email"
        onConfirm={() => handleEmailError()}
        confirmBtnText="Try again"
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >
        Could not send the policy document email
      </AlertDialog>
    </>
  )
}

export default EmailDocument
